var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconshopping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.428,
    height: 26.482,
    viewBox: "0 0 24.428 26.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconshopping",
    transform: "translate(-3 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M7.886,1.5H22.542a1.227,1.227,0,0,1,.977.481L27.183,6.8a1.192,1.192,0,0,1,.244.722V24.371a3.642,3.642,0,0,1-3.664,3.611H6.664A3.642,3.642,0,0,1,3,24.371V7.519A1.192,1.192,0,0,1,3.244,6.8L6.908,1.981A1.227,1.227,0,0,1,7.886,1.5ZM21.931,3.907H8.5L5.443,7.92V24.371a1.214,1.214,0,0,0,1.221,1.2h17.1a1.214,1.214,0,0,0,1.221-1.2V7.92Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M26.206,9.907H4.221a1.2,1.2,0,1,1,0-2.407H26.206a1.2,1.2,0,1,1,0,2.407Z",
    transform: "translate(0 -1.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M16.607,20.722A6.07,6.07,0,0,1,10.5,14.7a1.222,1.222,0,0,1,2.443,0,3.665,3.665,0,0,0,7.328,0,1.222,1.222,0,0,1,2.443,0A6.07,6.07,0,0,1,16.607,20.722Z",
    transform: "translate(-1.393 -2.37)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconshopping);
export default __webpack_public_path__ + "static/media/Iconshopping.5ac463095c8c575bc2282e3e37116f16.svg";
export { ForwardRef as ReactComponent };